<script lang="ts" setup>
const props = defineProps<{
  isActive: boolean;
}>();

const emit = defineEmits<{
  toggle: [];
}>();
</script>

<template>
  <div
    class="expansion-panel"
    :class="{
      'expansion-panel--active': props.isActive,
    }"
  >
    <div
      class="expansion-panel__header"
      @click="emit('toggle')"
    >
      <slot name="header"></slot>
    </div>

    <div class="expansion-panel__wrap">
      <div class="expansion-panel__inner">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.expansion-panel {
  $this: 'expansion-panel';

  &--active {
    .#{$this}__wrap {
      grid-template-rows: 1fr;
    }
  }

  &__header {
    cursor: pointer;
  }

  &__wrap {
    display: grid;
    grid-template-rows: 0fr;
    transition: grid-template-rows $anim-primary;
  }

  &__inner {
    overflow: hidden;
  }
}
</style>
